module.exports = __webpack_public_path__ + "static/img/23.4bc50af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/23.png
// module id = Y7GM
// module chunks = 0